import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/lab-procedures/stoolBlood";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	stoolBlood: {
		id: "ktx.stoolBlood.title",
		defaultMessage: "Széklet vér vizsgálat (3X)"
	},
	result: {
		id: "ktx.stoolBlood.field.result",
		defaultMessage: "Eredmény"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "ktx_stoolBlood",
	value: {
		schemaId: "stoolBlood",
		title: messages.stoolBlood,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
